/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { feedItemSchema } from './get-feed-request';

export const getFeedResponseDataSchema = z.array(feedItemSchema);

export type IGetFeedResponseData = z.infer<typeof getFeedResponseDataSchema>;

export const getFeedResponseSchema = createApiResponseSchema(
  getFeedResponseDataSchema,
) as z.ZodSchema<IAPI<IGetFeedResponseData>>;

export type IGetFeedResponse = IAPI<IGetFeedResponseData>;
